import { Grid, Typography } from 'seagull';
import { RelationshipEffectiveDate } from "../../../../components/RelationshipEffectiveDate/RelationshipEffectiveDate";
import { toDateStampObject } from "../../../../models/time";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import styles from "./Cells.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function EffectiveDateCell(_ref) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const onClick = () => onOpenModal({
    width: '400px',
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Effective date',
        testid: 'edit-effective-date-modal',
        onSubmit: defaultBehavior => {
          defaultBehavior();
        },
        content: /*#__PURE__*/_jsx(Grid, {
          rowGap: "small",
          children: /*#__PURE__*/_jsx(RelationshipEffectiveDate, {
            fullWidth: true,
            className: styles.effectiveDate,
            value: draft.effectiveDateAsDate(),
            onChange: date => setDraft(draft.setEffectiveDate(date ? toDateStampObject(date) : null)),
            title: "Agreement effective date",
            description: "The date when you can start providing the services and bill the client."
          })
        })
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-effective-date-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "effective-date-".concat(index),
      children: draft.formattedEffectiveDate() || 'On acceptance'
    })
  });
}